import api from "api";
import { supportApiBase } from "api/constants";
import { useMutation } from "react-query";

export interface DeleteExerciseVars {
  id: number;
}

export const useDeleteExercise = () =>
  useMutation((data: DeleteExerciseVars) => {
    // @ts-ignore
    return api("DELETE /exercises/{id}", {
      params: [data.id],
      root: supportApiBase,
    });
  });
